export const DONE_BUTTON_STATUS = "DONE_BUTTON_STATUS";
export const SET_SUBMIT_BILL = "SET_SUBMIT_BILL";
